import { Injectable, OnDestroy } from "@angular/core";
import { EMPTY } from "rxjs";
import { PermissionService } from "./permission.service";
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionRefreshService implements OnDestroy {
  // 5 minutes
  private readonly TTL_MS = 5 * 60 * 1000;
  private intervalRef: ReturnType<typeof setInterval> | null = null;
  private objectId: string | null = null; 

  private visibilityHandler = () => {
    if (document.visibilityState === 'visible') {
      this.checkAndRefresh(); 
    }
  };

  constructor(private permissionService: PermissionService) { }

  start(objectId: string): void {
    if (this.intervalRef) {
      this.objectId = objectId;
      return;
    }

    this.objectId = objectId;
    this.checkAndRefresh();

    this.intervalRef = setInterval(() => {
      this.checkAndRefresh();
    }, this.TTL_MS);

    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  stop(): void {
    if (this.intervalRef) {
      clearInterval(this.intervalRef);
      this.intervalRef = null;
    }
    document.removeEventListener('visibilitychange', this.visibilityHandler);
    this.objectId = null;
  }

  private checkAndRefresh(): void {
    if (!this.objectId) return;

    if (this.isPermissionExpired()) {
      this.permissionService.loadUserData(this.objectId, true).pipe(
        catchError(err => {
          console.error('[PermissionRefreshService] Silent refresh failed:', err);
          return EMPTY;
        })
      ).subscribe();
    }
  }

  private isPermissionExpired(): boolean {
    const raw = localStorage.getItem('userData');
    if (!raw) return true;

    try {
      const parsed = JSON.parse(raw);
      const fetchedAt = parsed.permissionsFetchedAt;
      if (!fetchedAt) return true;
      return Date.now() - fetchedAt > this.TTL_MS;
    } catch {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
